import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.1 0C9.76863 0 9.5 0.268629 9.5 0.6V8.1C9.5 8.43137 9.76863 8.7 10.1 8.7H16.85C17.1814 8.7 17.45 8.43137 17.45 8.1C17.45 6.76587 17.0942 4.76942 16.0035 3.08621C14.8918 1.37063 13.0235 0 10.1 0ZM10.7 7.5L10.7 1.2231C12.8239 1.39046 14.1594 2.447 14.9965 3.73878C15.7815 4.95027 16.1323 6.38188 16.2244 7.5H10.7Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M7.86705 3.44991C8.19837 3.44408 8.46224 3.17078 8.45642 2.83946C8.45059 2.50814 8.17729 2.24427 7.84597 2.25009C3.77795 2.32158 0.5 5.63357 0.5 9.71195C0.5 13.835 3.85036 17.175 7.9801 17.175C11.8533 17.175 15.0402 14.2377 15.4219 10.4711C15.4554 10.1414 15.2152 9.84706 14.8855 9.81364C14.5558 9.78023 14.2615 10.0204 14.2281 10.3501C13.908 13.5078 11.2335 15.975 7.98011 15.975C4.5103 15.975 1.7 13.1695 1.7 9.71195C1.7 6.29199 4.44956 3.50996 7.86705 3.44991Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }